import React from "react";
import {connect} from 'react-redux';
import PageHeading from 'components/PageHeading';
import BlockModal from './BlockModal';
import BookingSchedule from './BookingSchedule';

const Bookings = () => {

	return (
		<React.Fragment>
			<PageHeading withCreate={false}/>
			<BookingSchedule/>
			<BlockModal/>
		</React.Fragment>
		)
}

export default connect()(Bookings)